export enum adminApplicantsCsvTypes {
    FETCH_ADMIN_APPLICANTS_CSV_REQUEST = "FETCH_ADMIN_APPLICANTS_CSV_REQUEST",
    FETCH_ADMIN_APPLICANTS_CSV_SUCCESS = "FETCH_ADMIN_APPLICANTS_CSV_SUCCESS",
    FETCH_ADMIN_APPLICANTS_CSV_FAILURE = "FETCH_ADMIN_APPLICANTS_CSV_FAILURE",
  }